import PropTypes from "prop-types";
import deferredStyles from "../NativeAppBanner/deferred.css";
import classnames from "classnames";

const AppLogo = ({ classes }) => {
  return (
    <img
      className={classnames(deferredStyles.sbAppIcon, classes)}
      src="/assets/images/core/asos-app-icon.png"
      alt=""
      loading="lazy"
      width="55"
      height="55"
    />
  );
};

AppLogo.propTypes = {
  classes: PropTypes.string
};

export default AppLogo;
